// extracted by mini-css-extract-plugin
module.exports = {"item":"testimonial-item_item__CzPsV","message":"testimonial-item_message__njHZh","name":"testimonial-item_name__mHPnm"};